<template>
  <Input type="password" v-bind="$attrs" @change="onChange($event.target.value)" />
</template>

<script lang="tsx" setup name="SmartInput">
import { Input } from 'ant-design-vue'
const props = defineProps({
  change: {
    type: Function
  }
})
const onChange = (val) => {
  if (props.change) {
    props.change(val)
  }
}
</script>
